import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { KnownItemTypes } from 'owa-calendar-surface-dategrid';
import getDefaultReminder from 'owa-calendar-forms-common/lib/utils/getDefaultReminder';
import refreshLocationSuggestions from '../utils/refreshLocationSuggestions';
import { orchestrator } from 'satcheljs';
import {
    updateSelectionItem,
    convertToSchedulingSelectionItem,
} from 'owa-calendar-scheduling-grid';
import {
    onReminderChanged,
    updateFreeBusy,
    onAllDayChanged,
    updateAllDay,
    updateIsAllDayEventExplicitlySet,
} from 'owa-calendar-compose-form-actions';
import { refreshTimeSuggestions } from 'owa-calendar-time-suggestions';
import { prefetchRoomsAvailabilityForRoomPanel } from '../utils/prefetchRoomsAvailabilityForRoomPanel';
import fetchRecurrentEventResourcesAvailability from '../utils/fetchRecurrentEventResourcesAvailability';
import triggerAppointmentTimeChanged from '../utils/triggerAppointmentTimeChanged';

export default orchestrator(updateAllDay, actionMessage => {
    const fullComposeViewState = getFullComposeViewState();
    const store = getComposeStore();
    let calendarEvent = store.event;
    const originalEvent = store.originalEvent;
    const hasIsAllDayEventChanged = actionMessage.isAllDayEvent != calendarEvent.IsAllDayEvent;

    onAllDayChanged(actionMessage.isAllDayEvent);

    if (actionMessage.isAllDayEventExplicitlySet) {
        updateIsAllDayEventExplicitlySet();
    }

    if (hasIsAllDayEventChanged) {
        onReminderChanged(getDefaultReminder(actionMessage.isAllDayEvent));

        if (actionMessage.isAllDayEvent) {
            updateFreeBusy('Free');
        } else {
            updateFreeBusy('Busy');
        }
    }

    // Pull the latest values after updating prop updates
    calendarEvent = store.event;

    refreshTimeSuggestions(calendarEvent, false /* attendeesChanged */);
    refreshLocationSuggestions();

    // Full compose can be null when the opened form is Quick compose
    if (fullComposeViewState) {
        updateSelectionItem(
            fullComposeViewState.schedulingGridScenarioId,
            convertToSchedulingSelectionItem(calendarEvent, KnownItemTypes.suggestedItems)
        );

        // if in fullCompose prefetch room availabilities
        prefetchRoomsAvailabilityForRoomPanel(
            calendarEvent.Start,
            calendarEvent.End,
            calendarEvent.IsAllDayEvent,
            calendarEvent.Recurrence,
            calendarEvent.RequiredAttendees,
            calendarEvent.OptionalAttendees,
            originalEvent
        );
    }

    // Fetch availability for the resources of recurrent event. This is only for logging for experiment. We fetch the availabilities for all rooms in the Location well
    // using GetRoomAvailability, even when the flight 'cal-mf-availabilityForRecurrence' is off, to compare this availabilities between treatment and control.
    // TODO: Remove this when experiment is over (https://exp.microsoft.com/Rollout?id=f3d8a340-9076-46ee-8db1-d8e17e131b38)
    fetchRecurrentEventResourcesAvailability(calendarEvent);
    triggerAppointmentTimeChanged(calendarEvent.ParentFolderId.Id);
});
